import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { PropsWithChildren, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { DIGITAL_ACCOUNT_ROUTES } from '../../../constants/routes';
import { STEPS } from '../model/constants/steps';
import StepList from '../ui/components/steps/StepList';

const StyledContainer = styled(Box)(({ theme }) => ({
  background: 'white',
  padding: '28px',
  minWidth: 0,
  [theme.breakpoints.down('md')]: {
    padding: '20px 0 0',
  },
}));

const StepsLayout = (props: PropsWithChildren) => {
  const location = useLocation();
  const fullPathname = location.pathname;

  const stepList = useMemo(() => {
    const path = fullPathname.split('/').pop() as keyof typeof DIGITAL_ACCOUNT_ROUTES; // "currency"
    if (DIGITAL_ACCOUNT_ROUTES[path]) {
      let foundedIndex = 0;

      STEPS.forEach((item, index) => {
        if (item.path === path) {
          foundedIndex = index;
        }
      });

      return STEPS.map((item, index) => ({
        ...item,
        isProgress: index <= foundedIndex,
        isCompleted: foundedIndex > index,
      }));
    }
    return STEPS;
  }, [fullPathname]);

  return (
    <StyledContainer>
      <Box sx={{ maxWidth: 920, m: 'auto' }}>
        <StepList
          list={stepList}
          imgSx={{ width: 48, height: 48 }}
          sx={{
            maxWidth: '100%',
            overflowX: 'auto',
            gap: 2,
            pb: 1,
            '& > *': { flexShrink: 0, width: { xs: 128, md: 'auto' } },
          }}
        />
      </Box>
      <Box sx={{ maxWidth: 420, m: 'auto', mt: 4 }}>{props.children}</Box>
    </StyledContainer>
  );
};

export default StepsLayout;
